// Keep event identity separate from a tab/filter change. A different event must
// receive a fresh workbench instance; old asynchronous requests cannot fill it.
export function positiveRouteId(value) {
  if (!/^[1-9]\d*$/.test(String(value || ''))) return undefined
  const number = Number(value)
  return Number.isSafeInteger(number) ? number : undefined
}

export function adminRouteKey(route) {
  return route.path === '/dragonboat/event/workbench'
    ? `${route.path}:${positiveRouteId((route.query || {}).eventId) || 'invalid'}`
    : route.path
}

export function workbenchTab(value) {
  if (value === 'registration-review' || value === 'participation') return 'event-entries'
  const tab = value === 'results-service' ? 'results-quick-entry' : value === 'scoring-board' ? 'results-center' : value
  return ['event-entries', 'results-quick-entry', 'results-center', 'category-config', 'stage-config', 'distance-config'].includes(tab) ? tab : 'event-entries'
}

export function resultsWorkspaceLocation(query = {}) {
  const eventId = positiveRouteId(query.eventId)
  if (!eventId) return null
  const target = { eventId: String(eventId), tab: 'results-quick-entry' }
  for (const field of ['categoryId', 'roundId']) {
    const id = positiveRouteId(query[field])
    if (id) target[field] = String(id)
  }
  return { path: '/dragonboat/event/workbench', query: target }
}
